import { getProduct, getProducts } from "../../core/api/product";

import Box from "../../components/Box";
import Layout from "../../components/Layout";
import PageContent from "../../components/PageContent";
import Product from "../../components/Product";
import React from "react";
import { getMenu } from "../../core/api/menu";
import { getFooter } from "../../core/api/core";

function ReskinnedProduct({ product, menuData, globalData }) {
  return (
    <Layout navItems={menuData} globalData={globalData}>
      <PageContent>
        <Box pt={60}>
          <Product
            product={product}
            metaDescription={`${product.brand.name} ${product.title} For Sale. Find a selection of eco-friendly, sustainable and ethical brands that are doing good for the environment and the people that inhabit it.`}
          />
        </Box>
      </PageContent>
    </Layout>
  );
}

export default ReskinnedProduct;

export async function getStaticProps({ params }) {
  const product = await getProduct(params.slug);
  const menuData = await getMenu();
  const globalData = await getFooter();

  if (!product) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      product,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  const products = await getProducts();

  const paths = products.map((product) => ({
    params: {
      slug: product.slug,
    },
  }));

  return {
    paths,
    fallback: "blocking",
  };
}
